/**
 * 
 * key
 * 
 */


const key = 'cGVuZGluZ1Byb2R1Y3RXSXNlQ2xpZW50Q291bnQ='

export default key 